// packages/shared/src/lib/crypto/challenge.ts
function toBase64(bytes: Uint8Array): string {
  let bin = '';
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin);
}

export async function sha256Base64(data: string): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(data));
  return toBase64(new Uint8Array(buf));
}

export interface ChallengeInput {
  method: string;
  path: string;
  body: string;
  timestamp: number;
  nonce: string;
}

export async function buildChallenge(input: ChallengeInput): Promise<string> {
  const hash = await sha256Base64(input.body);
  return [input.method, input.path, hash, input.timestamp, input.nonce].join('\n');
}

export function isFreshTimestamp(ts: number, now: number, toleranceMs = 60_000): boolean {
  return Math.abs(now - ts) <= toleranceMs;
}
